import script from "./WCMenuDropdownModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCMenuDropdownModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCMenuDropdownModern.vue?vue&type=style&index=0&id=ab845ce0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab845ce0"]])

export default __exports__